import request from '@/utils/request'

/**
 * 获取进货明细列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function getInoutInfoList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallReport/getInoutInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}